// Provider-native IDs are case-sensitive. Do not substitute display names or reservation alone.
const sourceFields = ['sourceAccountId', 'sourcePropertyId', 'sourceConversationId', 'sourceMessageId'];
function sourceIdentity(item) {
  if (!item.channel || sourceFields.some(field => typeof item[field] !== 'string' || !item[field].trim())) return null;
  if (item.destination) {
    try {
      const { bookingBinding, destinationKey } = require('./destination');
      if (item.sourceConversationId !== destinationKey(bookingBinding(item))) return null;
    } catch { return null; }
  }
  const provider = ['personal_email', 'diam_email'].includes(item.channel) ? 'email' : item.channel;
  const ids = sourceFields.map(field => item[field].trim());
  if (provider === 'email' && ids[0].includes('@')) ids[0] = ids[0].toLowerCase();
  return JSON.stringify([provider, ...ids]);
}
function sourceVerified(item) { const key = sourceIdentity(item); return Boolean(key && item.sourceKey === key); }
module.exports = { sourceFields, sourceIdentity, sourceVerified };
